/* ----------------------------------------
    App Configuration
---------------------------------------- */

const quickscan = [
    {
        title: 'quickscan_step_1_title',
        largeText: 'quickscan_step_1_large_text',
        text: 'quickscan_step_1_text',
        image: 'quickscan_step_1_image',

        options: [
            {
                text: 'yes',
                style: 'lightblue',
                to: 'next',
            },
            {
                text: 'no',
                style: 'gray',
                to: 'decline',
            },
        ],
        declined: {
            title: 'quickscan_declined_title',
            text: 'quickscan_step_1_declined_text',
            options: [
                {
                    text: 'quickscan_declined_back',
                    style: 'gray',
                    to: 'edit',
                }
            ],
        }
    },
    {
        title: 'quickscan_step_2_title',
        text: 'quickscan_step_2_text',
        options: [
            {
                text: 'yes',
                style: 'lightblue',
                to: 'next',
            },
            {
                text: 'no',
                style: 'gray',
                to: 'decline',
            },
        ],
        declined: {
            title: 'quickscan_declined_title',
            text: 'quickscan_step_2_declined_text',
            options: [
                {
                    text: 'quickscan_declined_back',
                    style: 'gray',
                    to: 'edit',
                }
            ],
        }
    },
    {
        title: 'quickscan_step_3_title',
        text: 'quickscan_step_3_text',
        options: [
            {
                text: 'yes',
                style: 'lightblue',
                to: 'next',
            },
            {
                text: 'quickscan_step_3_crowdfunding',
                style: 'gray',
                to: 'next',
            },
            {
                text: 'no',
                style: 'gray',
                to: 'decline',
            },
        ],
        declined: {
            title: 'quickscan_declined_title',
            text: 'quickscan_step_3_declined_text',
            options: [
                {
                    text: 'quickscan_declined_back',
                    style: 'gray',
                    to: 'edit',
                }
            ],
        }
    },
    {
        title: 'quickscan_step_4_title',
        text: 'quickscan_step_4_text',
        icon: 'quickscan_step_4_icon',
        options: [
            {
                text: 'Account aanmaken',
                style: 'lightblue',
                to: '/register',
            },
            {
                text: 'Inloggen',
                style: 'gray',
                to: '/login',
            }
        ]
    }
];

/* ----------------------------------------
    Export Module
---------------------------------------- */

module.exports = {
    quickscan
};
